<div class="loading-shade" *ngIf="isLoadingResults">
	<mat-spinner diameter="80" *ngIf="isLoadingResults"></mat-spinner>
</div>
<div *ngIf="bShowSearchForm">
	<div class="row">
		<mat-card-title>
			<span style="padding-left:10px;margin-top:5px;font-size:21px;">School Districts</span>
		</mat-card-title>
	</div>
	<div class="row card-container">
		<div class="cardSearchBy" style="min-width:300px;">
			<app-search-by-districts-layer (onSearchParmEvent)="onSearchParmEvent($event)" (onResetEvent)="onResetMe()"
				 #child2>
			</app-search-by-districts-layer>
		</div>
		<div class="cardLocation">
			<app-districts-location-layer (eventEmitterSchoolDistrict)="districtsInputSelected($event)"
			(eventEmitterCounty)="countiesInputSelected($event)" (eventEmitterRegioncode)="regionsInputSelected($event)"
			[showDistrictDropdown]="false" #child6></app-districts-location-layer>
		</div>
	</div>
	<div class="row">
		<!-- style="min-width:580px;" [widthPercent]=90  -->
		<app-msin-mat-table-districts [dataSource]="dataSource" 
			[searchParm]="searchParm" 
			[searchFilter]="searchFilter"
			[columnList]="['selectView','REGIONS.CODE','COUNTy.COUNTY_CODE','DISTRICTS', 'NCES']" 
			[spacingTop]=20 [showViewIcon]="true" [canClearFilter]="true" [filterPlaceholder]="filterPlaceholder"
			(onIsLoadingResultsEvent)="onIsLoadingResultsEvent($event)" (onRegionChangeEvent)="onRegionChangeEvent($event)"
			[isLoadingResults]="false" (onSearchErrorEvent)="catchSearchError($event)" (onCreateEvent)="onCreateEvent($event)" 
			[showPagination]="true" #child>
		</app-msin-mat-table-districts>
		<!--[headerColor]="blue" -->
	</div>
</div>

